import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import { Router } from '@reach/router'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import { navigateParaHome } from '../../../../utils/rotas/navigate'
import { URLS, STATUS_SOLICITOU_CANCELAMENTO, STATUS_AGUARDANDO_CANCELAMENTO, STATUS_CANCELADO } from '../../../../constants'
import { useGlobal } from '../../../../contexts/GlobalContext'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import { SolicitacaoCancelamentoProvider } from '../../../../contexts/SolicitacaoCancelamentoContext'
import { TITULO_PAGINA, TITULO_PAGINA_SUSPENSAO_CONCLUSAO, getDescricao, DESCRICAO_MODAL, TITULO_MODAL, ACAO_BOTAO_MODAL, TEXTO_DUVIDAS, EMAIL_CONTATO_TAG, TITULO_PAGINA_SUSPENSAO, TITULO_PAGINA_AVISO_MULTA } from './constantsCancelarAssinatura'
import modalBg from '../../../../assets/imagens/modal-cancelamento.svg'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../utils/helpers/helpersAssinatura'
import { isEmptyObject, objetoTemPropriedade } from '../../../../utils/helpers/helpers'
import PaginaNaoEncontrada from '../../../../containers/PaginaNaoEncontrada/PaginaNaoEncontrada'

import Suspensao from './Suspensao/Suspensao'
import LazyComponent from '../../../../components/LazyComponent/LazyComponent'
import ArgumentosProduto from './ArgumentosProduto/ArgumentosProduto'
import AvisoMulta from './AvisoMulta/AvisoMulta'
import ConclusaoSuspensao from './ConclusaoSuspensao/ConclusaoSuspensao'
import MotivosCancelamento from './MotivosCancelamento/MotivosCancelamento'
import ConclusaoCancelamento from './ConclusaoCancelamento/ConclusaoCancelamento'
import MotivosSuspensao from './MotivosSuspensao/MotivosSuspensao'

const Decricao = styled.p`
  margin-bottom: 30px;
`

const Titulo = styled.h1`
  margin: 15px 0 10px 0;
  ${( { margin } ) => margin && `margin-bottom: 60px;`}

  @media ( max-width: ${StyleGuide.mediaQuery.tablet} ) {
    margin: 25px auto 10px auto;
    max-width: 70%;
  }

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    ${( { margin } ) => margin ? `margin: 15px 0 20px;` : `margin: 15px 0 5px 0;`}
    max-width: 100%;
  }
`

const ModalWrapper = styled.div`
  display: block;
  text-align: center;

  .wrapper__button__modal {
    align-items: center;
    margin: 70px auto 40px;
    color: ${StyleGuide.cores.branco};

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      margin: 40px auto 0px;
    }
  }

  h3 {
    color: ${StyleGuide.cores.azul};
    ${StyleGuide.boldFonte};
    margin: 20px 0;
  }

  .descricao__modal > a {
    color: ${StyleGuide.cores.azul};
  }

  .descricao__modal:not(:last-of-type) {
    margin-bottom: 30px;
  }
`

const CancelarAssinatura = ( { location } ) => {
  const [ descricao, setDescricao ] = useState()
  const [ modalPermanecer, setModalPermanecer ] = useState()
  const [ assinaturaModalidadeURL, setAssinaturaModalidadeURL ] = useState()
  const [ toggleDescricao, setToggleDescricao ] = useState( true )
  const { dadosGlobaisAssociado, modalidadeURL, nomeAssociado }= useGlobal()

  useEffect( () => {
    if ( nomeAssociado ) {
      setDescricao( getDescricao( nomeAssociado ) )
    }
  }, [ nomeAssociado ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas.length && modalidadeURL ) {
      const assinatura = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )
      setAssinaturaModalidadeURL( assinatura )
    }
  }, [ dadosGlobaisAssociado, modalidadeURL ] )

  if ( !isEmptyObject( assinaturaModalidadeURL ) && objetoTemPropriedade( assinaturaModalidadeURL, 'status' ) && modalidadeURL ) {
    if ( assinaturaModalidadeURL.status === STATUS_CANCELADO || assinaturaModalidadeURL.status === STATUS_AGUARDANDO_CANCELAMENTO || assinaturaModalidadeURL.status === STATUS_SOLICITOU_CANCELAMENTO ) {
      navigateParaHome()
      return null
    } else {
      return (
        <SolicitacaoCancelamentoProvider>
          <Fragment>
            { modalPermanecer ?
              <Modal
                altura="auto"
                largura="465px"
                onShowModal={ () => setModalPermanecer( false ) }
                show={ modalPermanecer }
              >
                <ModalWrapper>
                  <h3>
                    { TITULO_MODAL }
                  </h3>

                  <p className="descricao__modal">
                    { DESCRICAO_MODAL }
                  </p>

                  <p className="descricao__modal">
                    { TEXTO_DUVIDAS }

                    <a href={ `mailto:${EMAIL_CONTATO_TAG}` }> { EMAIL_CONTATO_TAG } </a>
                  </p>

                  <div className="wrapper__button__modal">
                    <Button
                      onClick={ navigateParaHome }
                      tema={ Button.BOTAO_CURADORIA }
                    >
                      { ACAO_BOTAO_MODAL }
                    </Button>
                  </div>
                </ModalWrapper>
              </Modal> : null}

            <BreadcrumbGlobal
              exactPath="cancelar-assinatura"
              nomeAlternativo="Solicitação de cancelamento"
              palavrasExcluidas={ /motivos-cancelamento|conclusao|suspensao|aviso-multa/u }
            />

            { location.pathname.includes( 'suspensao' ) ?
              <Titulo>
                { location.pathname.includes( 'conclusao' ) ?
                  TITULO_PAGINA_SUSPENSAO_CONCLUSAO : TITULO_PAGINA_SUSPENSAO }
              </Titulo> :
              <Fragment>
                <Titulo>
                  { !location.pathname.includes( 'aviso-multa' ) ? TITULO_PAGINA : TITULO_PAGINA_AVISO_MULTA }
                </Titulo>

                { toggleDescricao && !location.pathname.includes( 'aviso-multa' ) ?
                  <Decricao>
                    { descricao }
                  </Decricao> : null}
              </Fragment>}

            <Router>
              <PaginaNaoEncontrada default />

              <LazyComponent
                Component={ ArgumentosProduto }
                currentRoute={ URLS.CANCELAR_ASSINATURA_INICIAL }
                onClickPermanecer={ () => setModalPermanecer( true ) }
                path="/"
              />

              <LazyComponent
                Component={ AvisoMulta }
                currentRoute={ URLS.CANCELAR_ASSINATURA_AVISO_MULTA }
                onClickPermanecer={ () => setModalPermanecer( true ) }
                path="/aviso-multa"
              />

              <LazyComponent
                Component={ MotivosCancelamento }
                currentRoute={ URLS.CANCELAR_ASSINATURA_MOTIVOS_CANCELAMENTO }
                path="/motivos-cancelamento"
              />

              <LazyComponent
                Component={ ConclusaoCancelamento }
                path="/conclusao"
                setToggleDescricao={ setToggleDescricao }
              />

              <LazyComponent
                Component={ Suspensao }
                currentRoute={ URLS.CANCELAR_ASSINATURA_SUSPENSAO }
                path="/suspensao"
              />

              <LazyComponent
                Component={ MotivosSuspensao }
                currentRoute={ URLS.CANCELAR_ASSINATURA_MOTIVOS_SUSPENSAO }
                path="/suspensao/motivos-suspensao"
              />

              <LazyComponent
                Component={ ConclusaoSuspensao }
                currentRoute={ URLS.CANCELAR_ASSINATURA_SUSPENSAO_CONCLUSAO }
                path="/suspensao/conclusao"
              />
            </Router>
          </Fragment>
        </SolicitacaoCancelamentoProvider>
      )
    }
  }
  return null
}

CancelarAssinatura.propTypes = {
  'location': object.isRequired
}

export default CancelarAssinatura

